<template>
  <div>
    <div class="tw:flex tw:flex-col tw:gap-y-1 tw:mb-5">
      <h3 class="tw:text-xl tw:font-bold">{{ $t('tbs_images_tips_header') }}</h3>
      <p class="tw:text-sm">{{ $t('tbs_images_tips_subtext') }}</p>
    </div>
    <BlueSidebarCard />
    <div class="tw:flex tw:flex-col tw:gap-y-2">
      <SidebarCard
        :title="$t('tbs_main_image_guidelines_header')"
        :icon="MainImageIcon"
        :defaultOpen="true"
        type="main-image-tips"
      >
        <template #imagesCardContent>
          <MainImageSidebarContent />
        </template>
      </SidebarCard>
      <SidebarCard
        :title="$t('tbs_image_quality_header')"
        :icon="QualityIcon"
        :defaultOpen="false"
        type="images-quality"
      >
        <template #imagesCardContent>
          <ul class="tw:flex tw:gap-y-1 tw:flex-col">
            <li
              class="tw:text-sm tw:flex tw:flex-row tw:items-center"
              v-for="(qualityPoint, index) in qualityPoints"
              :key="index"
            >
              <span class="tw:flex tw:h-1 tw:w-1 tw:rounded-full tw:bg-blue-700 tw:mr-2" />{{ $t(qualityPoint) }}
            </li>
          </ul>
        </template>
      </SidebarCard>
      <SidebarCard
        :title="$t('tbs_images_not_permitted_header')"
        :icon="NotPermittedIcon"
        :defaultOpen="false"
        type="images-not-permitted"
      >
        <template #imagesCardContent>
          <NotPermittedSidebarContent />
        </template>
      </SidebarCard>
      <div class="tw:bg-gray-200 tw:p-4 tw:rounded-lg">
        <p v-html="$t('tbs_images_footnote')" class="tw:text-sm" />
      </div>
    </div>
  </div>
</template>
<script setup>
import SidebarCard from '@/components/propertyDetails/propertyImages/SidebarCard.vue'
import BlueSidebarCard from '@/components/propertyDetails/propertyImages/BlueSidebarCard.vue'
import MainImageSidebarContent from '@/components/propertyDetails/propertyImages/MainImageSidebarContent.vue'
import NotPermittedSidebarContent from '@/components/propertyDetails/propertyImages/NotPermittedSidebarContent.vue'

const MainImageIcon = new URL(`../../../assets/img/property-details/property-images/MainImageIcon.svg`, import.meta.url)
const QualityIcon = new URL(`../../../assets/img/property-details/property-images/QualityIcon.svg`, import.meta.url)
const NotPermittedIcon = new URL(
  `../../../assets/img/property-details/property-images/NotPermittedIcon.svg`,
  import.meta.url
)

const qualityPoints = ['tbs_image_quality_1', 'tbs_images_quality_2', 'tbs_images_quality_3']
</script>
